import { actions as ThemeActions } from '../../store/ThemeStore';
import { get } from 'lodash';

const onCssLengthChange = (dispatch, prefix) => (themeProperty, unitFilter) => event =>
    dispatch(
        ThemeActions.modifyThemeKey(
            `${prefix ? `${prefix}.` : ''}${themeProperty}`,
            unitFilter.filter(get(event, ['target', 'value'], event))
        )
    );
const onThemePropChange = (dispatch, prefix, globalCallback) => (themeProperty, callback) => event => {
    dispatch(
        ThemeActions.modifyThemeKey(
            `${prefix ? `${prefix}.` : ''}${themeProperty}`,
            get(event, ['target', 'value'], event)
        )
    );
    globalCallback && typeof globalCallback === 'function' && globalCallback(dispatch);
    callback && typeof callback === 'function' && callback(dispatch);
};
const parseUrlProperty = (originalValue = '') => {
    const myRegexp = /url\((.*)\)/g;
    const match = myRegexp.exec(originalValue);
    return match ? match[1].replace(/^\'|\'$/g, '') : '';
};

export { onCssLengthChange, onThemePropChange, parseUrlProperty };



// WEBPACK FOOTER //
// ./src/components/helpers/ThemeStoreHelpers.js